// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/down-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Calendar CSS Start */

.rbc-event {
  background-color: #5057ff !important;
  padding: 2px 5px 4px 5px !important;
}

.rbc-event-content {
  font-size: 12px !important;
  font-weight: normal !important;
}

.rbc-event-content strong {
  font-size: 12px !important;
  font-weight: normal !important;
}

.rbc-event-content .mt-1 {
  margin-top: 0 !important;
}

.text-count {
  color: #5057ff !important;
}

.rbc-day-bg + .rbc-day-bg {
  border-left: 4px solid #fff !important;
}

.rbc-month-row + .rbc-month-row {
  border-top: 4px solid #fff !important;
}

.rbc-month-view {
  border: 0px solid #fff !important;
}

.rbc-date-cell {
  padding-right: 10px !important;
  font-size: 14px !important;
}

.rbc-row-bg {
  background: #363636 !important;
  border-radius: 0px !important;
}

.rbc-button-link {
  color: #fff !important;
}

.rbc-event {
  margin: 0px 5px 2px 5px !important;
  width: 86% !important;
}

.rbc-off-range-bg {
  background: #545353 !important;
}

.rbc-today {
  background-color: #000000 !important;
}

/* Calendar CSS End */

.form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 1rem;
  background-position: right 0.7rem center;
}

.ProgressBar-size span {
  font-size: 0.875rem !important;
}

.rbc-show-more {
  padding: 2px 6px !important;
  margin-left: 6px !important;
  border-radius: 8px !important;
  font-size: 12px !important;
  font-weight: normal !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/App.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qBAAqB;;AAErB;EACE,yDAAkD;EAClD,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;AAChC","sourcesContent":["/* Calendar CSS Start */\n\n.rbc-event {\n  background-color: #5057ff !important;\n  padding: 2px 5px 4px 5px !important;\n}\n\n.rbc-event-content {\n  font-size: 12px !important;\n  font-weight: normal !important;\n}\n\n.rbc-event-content strong {\n  font-size: 12px !important;\n  font-weight: normal !important;\n}\n\n.rbc-event-content .mt-1 {\n  margin-top: 0 !important;\n}\n\n.text-count {\n  color: #5057ff !important;\n}\n\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 4px solid #fff !important;\n}\n\n.rbc-month-row + .rbc-month-row {\n  border-top: 4px solid #fff !important;\n}\n\n.rbc-month-view {\n  border: 0px solid #fff !important;\n}\n\n.rbc-date-cell {\n  padding-right: 10px !important;\n  font-size: 14px !important;\n}\n\n.rbc-row-bg {\n  background: #363636 !important;\n  border-radius: 0px !important;\n}\n\n.rbc-button-link {\n  color: #fff !important;\n}\n\n.rbc-event {\n  margin: 0px 5px 2px 5px !important;\n  width: 86% !important;\n}\n\n.rbc-off-range-bg {\n  background: #545353 !important;\n}\n\n.rbc-today {\n  background-color: #000000 !important;\n}\n\n/* Calendar CSS End */\n\n.form-select {\n  background-image: url(../../public/down-arrow.svg);\n  background-size: 1rem;\n  background-position: right 0.7rem center;\n}\n\n.ProgressBar-size span {\n  font-size: 0.875rem !important;\n}\n\n.rbc-show-more {\n  padding: 2px 6px !important;\n  margin-left: 6px !important;\n  border-radius: 8px !important;\n  font-size: 12px !important;\n  font-weight: normal !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
